import { takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { getLastSyncDate } from './investmentHoldingsV2Selectors';
import { mkInvestmentHoldingV2 } from './investmentHoldingsV2Types';
import * as actions from './investmentHoldingsV2Actions';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'investment holdings',
  resourceBaseUrl: '/v2/investments/holdings',
  getLastSyncDate,
  transformResponseToResources: (response) => response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentHoldingV2(data)),
  // transformResourceToRequestData: (resource) => ({
  //   ...(resource.toJS ? resource.toJS() : resource),
  //   transaction: transformTransactionToRequestData(resource.transaction),
  // }),
  // transformResponseToResources: (response: any) => response.data.resources.map((data) => mkScheduledTransaction({
  //   ...data,
  //   transaction: transformRequestDataToTransaction(data.transaction),
  // })),
  ...props,
});

export function* getInvestmentHoldingsV2ActionWatcher(): Generator<*, *, *> {
  const config = mkResourceConfig({
    successAction: actions.getInvestmentHoldingsV2Success,
    failureAction: actions.getInvestmentHoldingsV2Failure,
  });
  yield takeEvery(actions.getInvestmentHoldingsV2, getQcsSyncResources, config);
}

export function* createInvestmentHoldingV2ActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.createInvestmentHoldingV2Success,
    failureAction: actions.createInvestmentHoldingV2Failure,
  });
  yield takeEvery(actions.createInvestmentHoldingV2, qcsSyncCreateResource, config);
}

export function* updateInvestmentHoldingV2ActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.updateInvestmentHoldingV2Success,
    failureAction: actions.updateInvestmentHoldingV2Failure,
  });
  yield takeEvery(actions.updateInvestmentHoldingV2, qcsSyncUpdateResource, config);
}

export function* deleteInvestmentHoldingV2ActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.deleteInvestmentHoldingV2Success,
    failureAction: actions.deleteInvestmentHoldingV2Failure,
  });
  yield takeEvery(actions.deleteInvestmentHoldingV2, qcsSyncDeleteResource, config);
}

export default [
  getInvestmentHoldingsV2ActionWatcher,
  createInvestmentHoldingV2ActionWatcher,
  updateInvestmentHoldingV2ActionWatcher,
  deleteInvestmentHoldingV2ActionWatcher,
];
